
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.58 3.414a7.81 7.81 0 00-5.547-2.289c-4.322 0-7.84 3.5-7.842 7.805a7.756 7.756 0 001.047 3.902l-1.113 4.043 4.157-1.085c1.151.623 2.44.95 3.748.949h.003c4.322 0 7.84-3.501 7.842-7.805a7.74 7.74 0 00-2.295-5.52zM9.033 15.422H9.03a6.531 6.531 0 01-3.317-.905l-.238-.14-2.467.644.658-2.394-.155-.246a6.45 6.45 0 01-.996-3.451c0-3.577 2.925-6.487 6.52-6.487a6.504 6.504 0 016.516 6.492c-.001 3.576-2.925 6.487-6.518 6.487zm3.575-4.859c-.196-.097-1.16-.57-1.339-.634-.178-.065-.31-.098-.44.098-.131.195-.507.632-.621.764-.114.132-.229.146-.424.049-.196-.098-.828-.304-1.576-.968a5.88 5.88 0 01-1.09-1.35c-.115-.196-.013-.302.086-.399.088-.087.195-.228.293-.341.099-.114.131-.196.196-.326s.033-.244-.016-.341c-.049-.098-.44-1.058-.604-1.448-.16-.38-.32-.33-.44-.335a7.965 7.965 0 00-.377-.007.722.722 0 00-.522.244c-.18.195-.686.668-.686 1.627s.703 1.887.8 2.017c.097.13 1.382 2.1 3.347 2.945.365.156.738.293 1.118.41.47.149.896.128 1.234.078.376-.056 1.16-.472 1.323-.928.162-.455.163-.845.114-.927-.049-.081-.18-.13-.376-.228z","fill":"#4D4C4C"}})])
          )
        }
      }
    